module.exports = __webpack_public_path__ + "img/icon-back.06010534.png";